<template>
  <v-app anchor-root
    v-resize="onWindowResize"
    :device="device">

    <!--Layout-->
    <router-view
    ></router-view>

    <appExtra
      v-if="applicationLoaded"
    ></appExtra>

  </v-app>
</template>

<script>
import Vue from 'vue'
import tracking from 'libs/tracking.js'
Vue.prototype.$tracking = tracking
import appExtra from 'appExtra/appExtra.vue'
import base from 'app/base.js'
import application from 'app/application.js'
export default {
  name: 'App',
  mixins: [base, application],
  created() {
    this.applicationCreated()
    this.baseAppCreated()
  },
  mounted() {
    this.baseAppMounted()
  },
  components: {
    appExtra,
  },
}
</script>

<style src="prismjs/themes/prism.css"></style>
<style src="viewerjs/dist/viewer.css"></style>
<style lang="sass" src="assets/sass/base.sass" type="text/sass"></style>
<style lang="sass" src="assets/sass/app.sass" type="text/sass"></style>
<style lang="sass" type="text/sass">
@media print
  *[anchor-layout]
    padding-left: 0 !important
</style>